import React from 'react';
import { Select } from 'antd';
import FormItem from '../FormItem/FormItem';

const { Option } = Select;

const SelectField = ({
  label,
  form,
  name,
  options,
  className,
  inline = false,
  colon = false,
  selectOptions,
  selectProps,
  valueKey = 'value',
  contentKey = 'value',
  searchKey = 'searchText',
  ...props
}) => {
  return (
    <FormItem {...props} colon={colon} label={label} className={className}>
      {form.getFieldDecorator(
        name,
        options
      )(
        <Select {...selectProps}>
          {selectOptions.map((option) => (
              <Option
                key={option[valueKey]}
                value={option[valueKey]}
                searchtext={option[searchKey]}
              >
                {option[contentKey]}
              </Option>
            ))}
        </Select>
      )}
    </FormItem>
  );
};

export default SelectField;
